import React from 'react';
import { Checkbox, FormControlLabel, FormGroup, FormLabel, Grid } from '@mui/material';
import { ICampoIndiceProps } from './ICampoIndiceProps';

export const CampoCheckbox: React.FC<ICampoIndiceProps> = ({ indice, valor, disabled, onChange }) => {
    const selecionados = (valor ?? '').split(', ').filter((v) => v.trim() !== '');

    return (
        <Grid item xs={12} key={indice.idIndice}>
            <FormGroup key={'FormGroup=' + indice.idIndice}>
                <FormLabel key={'FormLabel' + indice.idIndice}>{indice.nomeIndice}</FormLabel>
                {!!indice.opcoes &&
                    indice.opcoes.split('^ ').map((op) => (
                        <FormControlLabel
                            key={op + '-' + indice.idIndice}
                            checked={selecionados.includes(op)}
                            control={
                                <Checkbox
                                    disabled={disabled}
                                    onChange={(event) => {
                                        const novo = event.target.checked ? [...selecionados, op] : selecionados.filter((v) => v !== op);
                                        onChange(novo.join(', '));
                                    }}
                                />
                            }
                            label={op}
                        />
                    ))}
            </FormGroup>
        </Grid>
    );
};
